import { HTMLAttributeAnchorTarget, ReactElement } from 'react';
import cx from 'clsx';
import { TitleContainer } from 'components/TitleContainer';
import { EnterpriseLink } from 'components/EnterpriseLink';
import { clampLine } from 'styles/style.css';

export type CampaignWidgetProps = {
  id: number;

  title: string;
  number: string;
};

export function CampaignWidget({
  id,
  number,
  title,
  link,
  flat,
  className,
  target = '_blank',
}: CampaignWidgetProps & {
  link?: boolean;
  target?: HTMLAttributeAnchorTarget;
  flat?: boolean;
  className?: string;
}): ReactElement {
  const content = link ? (
    <EnterpriseLink
      to={`/planning/campaigns/${id}/planning`}
      className={cx(clampLine, !flat && 'd-block')}
      target={target}
    >
      {title}
    </EnterpriseLink>
  ) : (
    title
  );

  return (
    <TitleContainer title={content} flat={flat} className={className} subtitle={number} testId={`campaign-${id}`} />
  );
}
